import VueToastify from 'vue-toastify';
import Vue from 'vue';

Vue.use(VueToastify, {
    position: 'top-right',
    hideProgressbar: true,
    maxToasts: 3,
    dragThreshold: 0,
    canPause: true,
    canTimeout: true,
    warningInfoDuration: 3000,
    successDuration: 5000,
    errorDuration: 60000,
});
